import { services } from '@config/services';
import type { OnboardRequest } from './types';

/**
 * Pure request builders for the onboard (accept-invite) endpoints. Kept
 * separate from the RTK Query endpoint definitions so the wire shapes are
 * lockable with `toEqual` in `onboardRequestBuilders.test.ts` (the same pattern
 * as `usersRequestBuilders`). URLs captured rank-1 from
 * api.dev.ordermesh.io (see docs/migration/onboard/link-graph.md).
 */
export const onboardRequestBuilders = {
  /** GET /user/v1/invitation/{code} (merchant) | /user/v1/vendor-invitation/{code} (vendor). */
  validateInvitation: ({ invitationCode, isVendor }: { invitationCode: string; isVendor: boolean }) => ({
    url: `${services.user}/v1/${isVendor ? 'vendor-invitation' : 'invitation'}/${encodeURIComponent(invitationCode)}`,
  }),

  /** GET /user/v1/password-policy. */
  passwordPolicy: () => ({ url: `${services.user}/v1/password-policy` }),

  /** POST /user/v1/invitation/onboard (merchant) | /user/v1/vendor-invitation/onboard (vendor). */
  onboard: ({ data, isVendor }: { data: OnboardRequest; isVendor: boolean }) => ({
    url: `${services.user}/v1/${isVendor ? 'vendor-invitation' : 'invitation'}/onboard`,
    method: 'POST' as const,
    body: data,
  }),
};
